<template>
    <Top />
    <!-- Spinner Start -->
    <div id="spinner" v-if="halamanloading"
        class="show bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center">
        <div class="spinner-border text-danger" style="width: 3rem; height: 3rem;" role="status">
            <span class="sr-only">Loading...</span>
        </div>
        &nbsp;<img src="../../../../src/assets/img/BerandaNgumahLogo.png" height="40">
        &nbsp;<span class="text-danger">..Loading...</span>
    </div>
    <!-- Spinner End -->
    <!-- Header Start -->
    <div class="container-fluid bg-breadcrumb" style="height: 350px !important;">
        <div class="container text-center" style="max-width: 900px;">
            <h3 class="text-white display-3 mb-4 wow fadeInDown pmisputih" data-wow-delay="0.1s">
                <span v-if="(bahasa === null) || (bahasa == 'ina')">PERTANYAAN UMUM</span>
                <span v-else>FREQUENTLY ASKED QUESTION</span>
            </h3>
            <ol class="breadcrumb justify-content-center mb-0 wow fadeInDown" data-wow-delay="0.3s">
                <li class="breadcrumb-item">
                    <a href="/">
                        <span v-if="(bahasa === null) || (bahasa == 'ina')">Beranda</span>
                        <span v-else>Home</span>
                    </a>
                </li>
                <li class="breadcrumb-item active text-warning">
                    <span v-if="(bahasa === null) || (bahasa == 'ina')">Pertanyaan yang Sering Diajukan</span>
                    <span v-else>Frequently Asked Question</span>
                </li>
            </ol>
        </div>
    </div>
    <!-- Header End -->
    <!-- Contact Start -->
    <div class="container-fluid blog py-2">&nbsp;</div>
    <div class="container-fluid blog py-2">
        <div class="container py-2">
            <div class="section-title mb-2 wow fadeInDown" data-wow-delay="0.1s">
                <h1 v-if="(bahasa === null) || (bahasa == 'ina')">Pertanyaan Umum</h1>
                <h1 v-else>FAQ</h1>
            </div>
            <div class="col-lg-12 col-xl-12 wow fadeInDown" data-wow-delay="0.1s">
                <div class="panel-group" id="accordion">
                    <div class="panel panel-default" v-for="(data, urutdata) in datanya" :key="urutdata">
                        <div class="panel-heading"
                            style="background-color:rgba(0, 92, 149, 0.8);padding-top: 5px;padding-left: 10px;padding-bottom: 1px;">
                            <h5 class="panel-title" data-toggle="collapse" :data-target="'#collapse1' + data.id"
                                style="cursor:pointer;">
                                <a data-toggle="collapse" data-parent="#accordion" :href="'#collapse1' + data.id"
                                    style="color:#FFFFFF;" v-if="(bahasa === null) || (bahasa == 'ina')"> {{ urutdata +
                                    1 }}. {{ data.nama }} </a>
                                <a data-toggle="collapse" data-parent="#accordion" :href="'#collapse1' + data.id"
                                    style="color:#FFFFFF;" v-else> {{ urutdata + 1 }}. {{ data.nama_eng }} </a>
                            </h5>
                        </div>
                        <div :id="'collapse1' + data.id" class="panel-collapse collapse">
                            <div class="panel-body" v-for="(detail, urutdetail) in data.detail" :key="urutdetail">
                                <span v-html="detail.nama" v-if="(bahasa === null) || (bahasa == 'ina')"></span>
                                <span v-html="detail.nama_eng" v-else></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="container-fluid blog py-2">&nbsp;</div>
    <!-- Contact End -->
    <a href="#" class="btn btn-dangerbulet btn-lg-square back-to-top text-white"><i class="fa fa-arrow-up"></i></a>
    <Footer />
</template>

<script>
import axios from 'axios';
import $ from 'jquery';
import swal from 'sweetalert2';

import Top from "./Template/Top.vue";
import Footer from "./Template/Footer.vue";

export default {
    components: {
        Top, Footer, swal
    },
    data() {
        return {
            halamanloading: true,
            tahun: new Date().getFullYear(),
            bahasa: localStorage.getItem("bahasasistem"),
            datapesan: '',
            datanya: [],
            project_id: process.env.VUE_APP_PROJECT_ID,

        };
    },
    methods: {
        async ambildata() {
            const mainAPINew = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
            });
            var random = Math.random();
            await mainAPINew.get("parastapainnovation-FAQ?random=" + random+ "&project_id=" + this.project_id).then(
                Response => {
                    this.datanya = [];
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.datanya = Response.data.content.data;
                        //alert(this.datanya);
                    }
                    else {
                        this.datapesan = "";
                        this.datanya = [];
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                this.datapesan = "";
                console.log(error);
            });
        },
    },
    mounted() {
        this.halamanloading = true;
        this.ambildata();
    },
}
</script>

<style></style>